import IconCheck from "@/app/(components)/generics/Icons/IconCheck";
import { useT } from "@/app/translations/useT";
import { HowItWorksBlock as HowItWorksBlockData } from "@/app/types/home/HowItWorksBlock";
import { UStyles } from "@/app/utils/UStyles";
import { formatStepNumber } from "../ConceptFlow/ConceptFlow.logic";
import styles from "./HowItWorks.module.css";
import HowItWorksMock from "./HowItWorksMock";

type Props = {
  block: HowItWorksBlockData;
  step: number;
  isReversed: boolean;
};

export default function HowItWorksBlock(props: Props) {
  const T = useT();
  const { block, step, isReversed } = props;

  return (
    <section className={UStyles.classNames(styles.block, isReversed ? styles.reversed : "")}>
      <div className={styles.text}>
        <span className={styles.step}>
          <span className={styles.stepNumber}>{formatStepNumber(step)}</span>
          <span className={styles.label}>{T(block.labelKey)}</span>
        </span>
        <h3 className={styles.title}>{T(block.titleKey)}</h3>
        <ul className={styles.bullets}>
          {block.bulletKeys.map((key) => (
            <li key={key} className={styles.bullet}>
              <span className={styles.bulletIcon}>
                <IconCheck color="currentColor" />
              </span>
              <span>{T(key)}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className={styles.visual} aria-hidden="true">
        <HowItWorksMock kind={block.mock} />
      </div>
    </section>
  );
}
